/** Five-step log scale for heat map shading (0 = lightest, -1 = none). */
export function shadeStep(v: number, max: number): number {
  if (v <= 0) return -1
  // Log scale: one big state (e.g. a head-office state) would otherwise wash
  // every other state out to the lightest shade.
  return Math.max(0, Math.min(4, Math.ceil((Math.log(v + 1) / Math.log(max + 1)) * 5) - 1))
}
